import React from "react";
import Artwork from "./Artwork";

import "./Gallery.css";

type Props = {
  tokens: string[];
};

const Gallery: React.FC<Props> = (props) => {
  const { tokens } = props;

  return (
    <div className="gallery-container">
      {tokens.map((token) => {
        return <Artwork key={token} token={token} />;
      })}
    </div>
  );
};

export default Gallery;
